// extracted by mini-css-extract-plugin
export var button = "_6x-7";
export var buttonRow = "_6x-6";
export var fadeIn = "_6x-1";
export var gradient = "_6x-0";
export var panel = "_6x-2";
export var panelIn = "_6x-3";
export var subtitle = "_6x-5";
export var title = "_6x-4";